import geolocationReducer from './reducer'
import ConnectedLocationSearch from './ConnectedLocationSearch.jsx'
import MultiSearch from './MultiSearch.jsx'

/**
 * Integrate geolocation state and UI into an app. Users can search geonames and
 * select from suggestions to give the app a geolocation state.
 */

export * from './actions'
export * from './sagas'

export { geolocationReducer, ConnectedLocationSearch, MultiSearch }
